import { Loader } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { Layout, ExtForm } from './components';
import { useExtFormPageController } from './hooks';
import { PasswordStep } from './components/PasswordStep';
import { NotFound } from '../NotFound';

export type FormsRoutingProps = {
  formSlug: string;
};

/**
 * External form page
 * @public
 */
export const ExtForms: React.FC = () => {
  const { formSlug } = useParams() as FormsRoutingProps;

  const {
    steps,
    currentStepsName,
    data,
    isLoading,
    setAccessCode,
    accessCodeRequired,
    active,
    prevStep,
    nextStep,
    setStepByIndex,
    sendForm,
  } = useExtFormPageController({
    formShareId: formSlug,
  });

  /**
   * Always render component because we need save the same hook calls between renders
   */
  const page404 = NotFound();

  /**
   * Loading state
   */
  if (isLoading && !accessCodeRequired) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }

  /**
   * Display password step if access code is required
   */
  if (accessCodeRequired && !data) {
    return (
      <Layout>
        <PasswordStep
          onSubmit={async ({ accessCode: newAccessCode }) => {
            await setAccessCode(newAccessCode);
          }}
        />
      </Layout>
    );
  }

  /**
   * Display 404 page if data is not found
   */
  if (!data) {
    return page404;
  }

  /**
   * Display form step
   */
  return (
    <ExtForm
      formSlug={formSlug}
      data={data}
      active={active}
      steps={steps}
      setStep={setStepByIndex}
      nextStep={nextStep}
      prevStep={prevStep}
      sendForm={sendForm}
      currentStepsName={currentStepsName}
    />
  );
};
